'use client';

import { atom } from 'jotai';

import type { Vehicle } from '../../Entities/Vehicle/Vehicle.entity';

export const currentCheckoutVehicleAtom = atom<Vehicle | null>(null);
